<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :ok-disabled="true"
    @setInnerFullscreen="setInnerFullscreen"
    :cancelText="language['common.closeButton']">
    <my-finished-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit" :innerFullscreen="innerFullscreen"></my-finished-form>
  </j-modal>
</template>

<script>

  import MyFinishedForm from './MyFinishedForm'

  export default {
    name: 'MyFinishedModal',
    components: {
      MyFinishedForm
    },
    data() {
      return {
        title: '',
        width: 1200,
        visible: false,
        disableSubmit: false,
        innerFullscreen:false,
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      setInnerFullscreen(val) {
        this.innerFullscreen = val
      },
      add() {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit(record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        this.$refs.realForm.submitForm();
      },
      submitCallback() {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      }
    }
  }
</script>